import React from 'react';
import { renderSvg } from '../manageAccount/renderSvg';
import moment from 'moment/moment'
const EditCard = (props) => {
    const { val } = props;
    return (
        <React.Fragment>
            <div className="card">
                <div className="cardHeader" >
                    <p>PNR: {val.BookingRefNo} | Booked on {val.BookingDateTime}</p>
                </div>
                <div className="cardContent">
                    <ul className="cardLeft">
                        <li>
                            <span className='circle'></span>
                            <div className="leftTop-content">
                                <h4>{val.FromCityName} on {moment(val.DptTime).format("HH:mm, ddd DD MMM")} </h4>
                                <p>{val.PickupName} </p>
                                <a>{renderSvg("viewMap")} <u>View on Map</u></a>
                            </div>
                        </li>
                        <li>
                            <span className='square'></span>
                            <div className="leftTop-content">
                                <h4>{val.ToCityName} on {moment(val.ArrivalTime).format("HH:mm, ddd DD MMM")}  </h4>
                                <p>{val.DroppoffName} </p>
                                <a>{renderSvg("viewMap")} <u>View on Map</u></a>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </React.Fragment>

    )
}

export default EditCard;